/*
 * @Description: 
 * @Author: shiao
 * @Date: 2022-02-22 14:33:45
 * @LastEditors: shiao
 * @LastEditTime: 2022-08-18 15:53:56
 */
const routes = [
    //新油卡
    {
        path: '/new-oli/recharge',
        component: () => import('../pages/recharge/oil-card/recharge.vue'),
        meta: {
            title: '油卡充值',
        },
    },
    {
        path: '/new-oli/cardmanage',
        component: () => import('../pages/recharge/oil-card/card-manage.vue'),
        meta: {
            title: '油卡管理',
        },
    },
    {
        path: '/new-oli/cardbind',
        component: () => import('../pages/recharge/oil-card/card-bind.vue'),
        meta: {
            title: '油卡绑定',
        },
    },
    {
        path: '/new-oli/cardInfoConfirm',
        component: () => import('../pages/recharge/oil-card/card-info-confirm.vue'),
        meta: {
            title: '确认信息',
        },
    },
    {
        path: '/new-oli/orderConfirm',
        component: () => import('../pages/recharge/oil-card/order-confirm.vue'),
        meta: {
            title: '订单确认',
        },
    },
    {
        path: '/new-oli/orderdetail',
        component: () => import('../pages/recharge/oil-card/order-detail.vue'),
        meta: {
            title: '订单详情',
        },
    },
    {
        path: '/new-oli/rechargeAgreement',
        component: () => import('../pages/recharge/recharge-agreement.vue'),
        meta: {
            title: '订单详情',
        },
    },
    
];
export default routes;